import { render, staticRenderFns } from "./FormBuilderListPage.vue?vue&type=template&id=a2202de4&"
import script from "./FormBuilderListPage.vue?vue&type=script&lang=ts&"
export * from "./FormBuilderListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports